/* eslint-disable react/jsx-filename-extension */
import React from "react";
import { render } from "react-dom";
import configureStore, { history } from "./redux/store/configureStore";
import Root from "./components/Root";
import appI18n from './i18n';
import "./sitemap.xml";
import "./styles/styles.scss";
import "@fortawesome/fontawesome-free/css/all.css";
// Yep, that"s right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.
// Tell webpack to load favicon.ico
const store = configureStore();
document.documentElement.lang = appI18n.resolvedLanguage;

render(
  <Root store={store} history={history} />,
  document.getElementById("app"),
);

if (module.hot) {
  module.hot.accept("./components/Root.jsx", () => {
    // eslint-disable-next-line global-require
    const NewRoot = require("./components/Root.jsx").default;
    render(<NewRoot store={store} history={history} />, document.getElementById("app"));
  });
}
